/** One row in `GET /api/agent/spam-queue`'s response array -- a flagged
 *  request awaiting (or already given) a review decision. `finalAction`
 *  starts `'pending'` (set by webyto-agent's Teams "Mark as SPAM" button or
 *  its auto-block gate) until an admin resolves it here. */
export interface AgentSpamQueueItem {
  id: number;
  requestId: number;
  detectedAt: string;
  spamReason: string | null;
  spamScore: number | null;
  spamDetail: string | null;
  finalAction: AgentSpamQueueFinalAction;
  reviewedBy: number | null;
  reviewedByName: string | null;
  reviewedAt: string | null;
  senderEmail: string | null;
  subject: string | null;
  receivedAt: string;
  requestStatus: string;
}

export type AgentSpamQueueFinalAction = 'pending' | 'discarded' | 'released' | 'quarantined';

/** `POST /api/agent/spam-queue/:id/resolve` accepts these three -- `pending`
 *  is a starting state, never something to resolve *to*. `released`'s exact
 *  effect is intentionally narrow today (see `AgentSpamQueue.ts`'s own
 *  header comment on the backend): it only flags this queue row, it does
 *  NOT restore the underlying request to an actionable state or create a
 *  document. Surfaced in the UI as-is rather than implying more than the
 *  backend actually does. */
export type AgentSpamQueueResolveAction = 'discarded' | 'released' | 'quarantined';

export const AGENT_SPAM_QUEUE_RESOLVE_ACTIONS: ReadonlyArray<{ title: string; value: AgentSpamQueueResolveAction }> = [
  { title: 'Відхилити (справді спам)', value: 'discarded' },
  { title: 'Повернути (не спам)', value: 'released' },
  { title: 'На карантин (потребує подальшого розгляду)', value: 'quarantined' },
];

/** One row in `GET /api/agent/spam-queue/senders`'s response array. */
export interface AgentSpamSenderItem {
  id: number;
  senderEmail: string;
  markedBy: number;
  markedByName: string | null;
  markedAt: string;
  requestId: number | null;
  occurrenceCount: number;
  lastSeenAt: string;
  autoBlock: boolean;
}

/** `POST /api/agent/spam-queue/:id/resolve` response. */
export interface AgentSpamQueueResolveResult {
  id: number;
  finalAction: AgentSpamQueueFinalAction;
}

/** `POST /api/agent/spam-queue/senders/:id/unblock` response. */
export interface AgentSpamSenderUnblockResult {
  id: number;
  autoBlock: false;
}
